<template>
  <div>
    <sc-field
      grouped
      position="is-right">

      <sc-select
        @input="changeState"
        placeholder="Alterar status">
        <option value="APPROVED">Aprovado</option>
        <option value="PAID">Pago</option>
        <option value="ANALYZED">Analisado</option>
      </sc-select>

    </sc-field>

    <sc-table
      :data="invoiceHistory"
      :loading="loadingInvoiceHistory"
      class="tab-history">

      <template slot-scope="props">

        <sc-table-column
          field="invoice_state"
          label="Status"
          :centered="false"
          sortable>
          <sc-invoice-audit-tag-status
            :status="props.row.invoice_state"/>
        </sc-table-column>

        <sc-table-column
          field="created"
          label="Data"
          sortable>
          {{ props.row.created | date('DD/MM/YYYY HH:mm') }}
        </sc-table-column>

        <sc-table-column
          field="description"
          label="Descrição"
          :centered="false"
          sortable>
          {{ props.row.description }}
        </sc-table-column>

        <sc-table-column
          field="attachment_url"
          label="Anexo">
          <button
            class="button is-primary is-small"
            @click="downloadInvoiceFilePerUrl(props.row.attachment_url)"
            v-if="props.row.attachment_url">
            <sc-icon icon="cloud-download-alt"
                     size="is-small" />
            <span>Baixar</span>
          </button>
        </sc-table-column>

        <sc-table-column
          field="user_name"
          label="Usuário"
          sortable>
          {{ props.row.user_name }}
        </sc-table-column>

      </template>

      <template slot="empty">
        <sc-table-empty />
      </template>

    </sc-table>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScField,
    ScSelect,
    ScTable,
    ScTableColumn,
    ScTableEmpty,
    ScIcon,
  } from '@intelipost-js/secure-components';
  import ScInvoiceAuditTagStatus from '../../../../components/sc-invoice-audit-tag-status/ScInvoiceAuditTagStatus';

  const { mapState, mapActions } = createNamespacedHelpers('recon/invoiceAudit');

  export default {
    name: 'tab-invoice-audit-detail-history',
    computed: {
      ...mapState([
        'invoice',
        'loadingInvoiceHistory',
        'invoiceHistory',
      ]),
    },
    methods: {
      ...mapActions([
        'getInvoiceHistory',
        'downloadInvoiceFilePerUrl',
        'changeState',
      ]),
    },
    created() {
      this.getInvoiceHistory(this.invoice.reconciliation_invoice_id);
    },
    components: {
      ScField,
      ScSelect,
      ScTable,
      ScTableColumn,
      ScTableEmpty,
      ScIcon,
      ScInvoiceAuditTagStatus,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/invoice-audit/pages/invoice-audit-detail/components/tab-history/TabInvoiceAuditDetailHistory.vue?53dcad3f